import { useContext } from 'react';
import ThemesContext from 'src/contexts/ThemesContext/ThemesContext';

const useThemes = () => {
  return useContext(ThemesContext);
};

export default useThemes;
